module.exports = __webpack_public_path__ + "static/media/courts-primary.f15c63cd.jpg";